import Categories from '@/Pages/MealPlanner/Categories';
import Recipes from '@/Pages/MealPlanner/Recipes';

const MealPlannerRoutes = [
  {
    breadcrumb: [{ path: '/meal-planner/categories', breadcrumbName: 'Meal Planner Categories' }],
    Component: Categories,
  },
  {
    breadcrumb: [{ path: '/meal-planner/recipes', breadcrumbName: 'Meal Planner Recipes' }],
    Component: Recipes,
  },
];

export default MealPlannerRoutes;
